import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function IconButton(props: {
  className?: string
  icon: IconProp
  size?: SizeProp
  link?: string
}) {
  return (
    <div
      className={`${props.className} bg-blue-600 hover:bg-blue-700 rounded-full h-8 w-8 mx-1 flex flex-row justify-center items-center`}
    >
      <a
        href={props.link}
        target='_blank'
        aria-label='Contact us with this method by clicking on this button.'
      >
        <FontAwesomeIcon icon={props.icon} size={props.size} />
      </a>
    </div>
  )
}
